import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { withFirebase } from "../../Firebase";
import {
  actionAddArray2Redux,
  selectARecord,
  initSelectedRecord,
  setUiFlag,
  loadAllStats,
  resetRedux,
  loadFbData,
  notifyUsers,
  getId,
  getAcctStatement,
  getAcctBalance
} from "../../../../store/actions";
import WorkerGrid from "../ContentGrid/WorkerGrid";
import OpenBazarGrid from "../ContentGrid/OpenBazarGrid";
import { Container, Preloader, Button } from "reactackle";
import getDefs from "../../../../staticData/getDefs";
import { searchRecords } from "../../searches/searchRecords";
import { getMenuList, getInitData } from "./getMenuList";
import "./landingPage.css";
import { throttle, debounce } from "throttle-debounce";
import GridFilters from "../ContentGrid/GridFilters";
import GridDateFilters from "../ContentGrid/GridDateFilters";
import { isMobile } from "react-device-detect";
import getExtendedOgDefs from "../../TableDefinitions/extendedOgDef";
import getInputField from "../customFields/getInputField";
import OrderPad from "./OrderPad";
import DirectAdmin from "./DirectAdmin";
import "./landingPage.css";
import { localState } from "../../../../staticData/rawState";
import termsMainPage from "./termsMainPage";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import SingleRecord from "../SingleRecord/SingleRecord";
import YouTube from "react-youtube";
import { LazyLoadImage } from "react-lazy-load-image-component";

class WorkerSecure extends Component {
  constructor(props) {
    super(props);
    ////console.log("...test... " + JSON.stringify(tableDefs));
    //console.log(window.location.hostname + " " + JSON.stringify(localState));
    this.state = {
      data: {
        path: "",
        payload: {
          paymentType: "",
          supplierInvoice: "",
          referenceNumber: "",
          paymentDate: ""
        }
      },
      message: "",
      hasLoaded: false,
      tableName: "deliveryRequest",
      tableDefs: getDefs(this.props.createTable),
      searchVal: "",
      showGrid: true,
      showDash: false,
      searchFilters: {},
      searchDateFilters: {},
      showFilters: true,
      showPivot: false,
      reRenderFlag: false,
      formDefs: getExtendedOgDefs(this.props.createTable),
      notInitialized: true,
      loginProgress: false,
      logview: [],
      stage: "login",
      loginProgress: false,
      localhost: localState.hostname,
      startButtonText: "LOADING ...",
      isSignedIn: true,
      notLoadedBasicData: true
    };
    this.getDataDebounced = debounce(1000, this.doStateUpdateForSearch);
    this.getDataThrottled = throttle(1000, this.doStateUpdateForSearch);
  }

  componentDidMount() {
    //    console.log(JSON.stringify(localState));
    if (
      this.state.notInitialized &&
      !this.props.firebase.auth &&
      this.props.firebase.auth === undefined
    ) {
      this.props.onSetUiFlag("operationType", "add");

      this.setState(prevState => {
        return {
          ...prevState
        };
      });
      this.props.firebase.doInitiate("BROOKLYNZ");
      this.setState(prevState => {
        return {
          ...prevState,
          notInitialized: false,
          phoneNumber:
            window.location.hostname === this.state.localhost
              ? this.state.phoneNumber
              : ""
        };
      });
      this.props.onSetUiFlag("notLoadedBasicData", true);
    }

    this.unregisterAuthObserver = this.props.firebase.auth.onAuthStateChanged(
      user => this.setState({ isSignedIn: !!user })
    );
    this.props.onSetUiFlag("loginProgress", false);
  }

  componentWillUnmount() {
    this.unregisterAuthObserver();
  }

  applyDataCondition = (singleRecord, dataCondition) => {
    let tmpRes = false;

    for (let p = 0; p < dataCondition.length; p++) {
      if (
        singleRecord[dataCondition[p]["colKey"]] ===
        dataCondition[p]["fieldVal"]
      ) {
        tmpRes = true;
      }

      if (
        singleRecord[dataCondition[p]["colKey"]] ===
        this.props.userProfile[dataCondition[p]["fieldVal"]]
      ) {
        tmpRes = true;
      }
    }
    //console.log("~~ returning: " + tmpRes);
    return tmpRes;
  };

  loadDataEx = allTableDets => {
    let recsLimit = 0;

    if (isMobile) {
      if (allTableDets.recMobileLimit) {
        recsLimit = parseInt(allTableDets.recMobileLimit);
      }
    } else {
      if (allTableDets.recMobileLimit) {
        recsLimit = parseInt(allTableDets.recLimit);
      }
    }

    let basePath = "/";
    let tableName = allTableDets.tableName;
    if (recsLimit > 0) {
      this.props.firebase.db
        .ref(basePath + tableName)
        .limitToLast(recsLimit)
        .on("value", snapshot => {
          let tmpArray = [];
          let fbOject = [];
          Promise.all([snapshot.val()]).then(res => {
            fbOject = res[0];
            if (fbOject && fbOject !== null && fbOject !== undefined) {
              Object.keys(fbOject).map(key => {
                let item = {
                  ...fbOject[key],
                  key: key
                };
                //console.log("~~ Linking " + JSON.stringify(allTableDets));
                if (
                  allTableDets.dataConditions &&
                  allTableDets.dataConditions !== undefined &&
                  allTableDets.dataConditions.length > 0
                ) {
                  //console.log(JSON.stringify(allTableDets.dataConditions));
                  if (
                    this.applyDataCondition(item, allTableDets.dataConditions)
                  ) {
                    tmpArray.push(item);
                  }
                } else {
                  tmpArray.push(item);
                }
              });
            }
            //reverse to have latest at the top
            //tmpArray.reverse();
            this.props.onAddRecord({
              path: tableName,
              payload: tmpArray
            });
          });
        });
    } else {
      this.props.firebase.db.ref(basePath + tableName).on("value", snapshot => {
        let tmpArray = [];
        let fbOject = [];
        Promise.all([snapshot.val()]).then(res => {
          fbOject = res[0];
          if (fbOject && fbOject !== null && fbOject !== undefined) {
            Object.keys(fbOject).map(key => {
              let item = {
                ...fbOject[key],
                key: key
              };
              //console.log("~~ Linking " + JSON.stringify(allTableDets));
              if (
                allTableDets.dataConditions &&
                allTableDets.dataConditions !== undefined &&
                allTableDets.dataConditions.length > 0
              ) {
                //console.log(JSON.stringify(allTableDets.dataConditions));
                if (
                  this.applyDataCondition(item, allTableDets.dataConditions)
                ) {
                  tmpArray.push(item);
                }
              } else {
                tmpArray.push(item);
              }
            });
          }
          //reverse to have latest at the top
          //tmpArray.reverse();
          this.props.onAddRecord({
            path: tableName,
            payload: tmpArray
          });
          this.setState(prevState => {
            return {
              ...prevState,
              formDefs: getExtendedOgDefs(this.props.createTable),
              tableDefs: getDefs(this.props.createTable)
            };
          });
        });
      });
    }
    //}
  };

  loadData = (tableName, isDeleted) => {
    //console.log(tableName);
    let recsLimit = 3000;
    if (isMobile) {
      recsLimit = 2000;
    }
    if (tableName === "attendance") {
      if (isMobile) {
        recsLimit === 2000;
      } else {
        recsLimit === 3000;
      }
    }
    let basePath = "/";
    if (isDeleted) {
      basePath = "/deletedRecs/";
    }
    this.props.firebase.db
      .ref(basePath + tableName)
      .limitToLast(recsLimit)
      .on("value", snapshot => {
        ////console.log("Linking " + tableName);
        let tmpArray = [];
        let fbOject = [];
        let projTempArray = [];
        Promise.all([snapshot.val()]).then(res => {
          //basic updating keys into objects
          fbOject = res[0];
          if (fbOject && fbOject !== null && fbOject !== undefined) {
            tmpArray = Object.keys(fbOject).map(key => ({
              ...fbOject[key],
              key: key
            }));
          }
          //reverse to have latest at the top
          //tmpArray.reverse();

          //filter project table for engineer and contributor
          if (
            tableName === "projects" &&
            (this.props.currUserRole === "ENGINEER" ||
              this.props.currUserRole === "CONTRIBUTOR")
          ) {
            projTempArray = tmpArray.filter(item => {
              return item.projectPhase === "IN FLIGHT";
            });

            //handle delete
            if (isDeleted) {
              this.props.onAddRecord({
                path: "deleted" + tableName,
                payload: projTempArray
              });
            } else {
              this.props.onAddRecord({
                path: tableName,
                payload: projTempArray
              });
            }
          } else {
            //handle delete
            if (isDeleted) {
              this.props.onAddRecord({
                path: "deleted" + tableName,
                payload: tmpArray
              });
            } else {
              this.props.onAddRecord({ path: tableName, payload: tmpArray });
            }
          }
        });
      });
  };

  getTopMenu = () => {
    if (isMobile) {
      return (
        <nav className="navbar navbar-default navbar-fixed-top">
          <div
            className="container-fluid"
            style={{
              paddingTop: "5px"
            }}
          >
            <div className="navbar-header">
              <button
                type="button"
                className="pull-left navbar-toggle collapsed"
                data-toggle="collapse"
                data-target="#navMenu"
                aria-expanded="false"
                style={{
                  marginLeft: "10px"
                }}
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
                <span className="icon-bar"></span>
              </button>

              <a
                className="navbar-brand"
                href="#"
                style={{
                  marginLeft: "10px",
                  marginRight: "-20px",
                  color: "black"
                }}
              >
                BCS
              </a>
            </div>
            <div className="collapse navbar-collapse" id="navMenu">
              <ul className="nav navbar-nav navbar-left">
                {this.fetchMenus()}
              </ul>
            </div>
          </div>
        </nav>
      );
    }
  };

  fetchMenus = () => {
    //console.log("Fetching...");
    //console.log("Props userMenu: " + JSON.stringify(this.props.userMenus));
    return getMenuList(
      true,
      this.isAdmin(),
      this.switchMenu,
      this.props.currUserRole,
      this.props.userMenus
    );
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    //console.log("val: " + val + " id: " + id + " isPayload: " + isPayload);
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  logoutApp = () => {
    let msgToApp = {
      actionType: "logOut",
      payload: {}
    };

    if (window && window.ReactNativeWebView) {
      //console.log("posing logout message to app");
      window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
    }
  };

  switchMenu = menuName => {
    if (this.refs && this.refs.searchText) {
      this.refs.searchText.value = "";
      this.doDelaySearch();
    }
    this.stateChangeHandler({}, "searchFilters", false);
    this.stateChangeHandler({}, "searchDateFilters", false);
    this.stateChangeHandler(false, "showPivot", false);

    if (menuName === "signout") {
      console.log("signing out");
      this.props.firebase.doSignOut();
      this.stateChangeHandler("startButtonText", "LOADING ...", false);
      this.props.onSignOut();
      this.logoutApp();
      this.stateChangeHandler("login", "stage", false);
      this.stateChangeHandler(false, "isSignIn", false);
      this.stateChangeHandler(false, "loginProgress", false);
      this.stateChangeHandler("deliveryRequest", "tableName", false);
    } else {
      if (menuName === "deliveryRequest") {
        this.stateChangeHandler("orderpad", "stage", false);
      }
      if (menuName === "openBazar") {
        this.stateChangeHandler("openBazarList", "stage", false);
      }
      if (menuName === "bcsHome") {
        this.stateChangeHandler("login", "stage", false);
      }
    }
  };

  isAdmin = () => {
    return this.props.isAdmin || this.props.isSuperAdmin;
  };

  handleDelete = (key, path, searchObj) => {
    this.props.firebase.db.ref("/" + path + "/" + key).remove();
    this.stateChangeHandler(true, "showGrid", false);
  };

  handleOrderEdit = (key, path, fullPayload) => {
    if (
      fullPayload &&
      (fullPayload.status === "" ||
        fullPayload.status === "NEW" ||
        fullPayload.status === undefined ||
        fullPayload.status === "WITH GROCER FOR PRICE")
    ) {
      console.log("changing stage");
      this.stateChangeHandler("orderpad", "stage", false);
      this.props.onSelectRecord({ path: path, key: key });
      this.props.onSetUiFlag("operationType", "update");
    }
  };

  handleBazarEdit = (key, path, fullPayload) => {
    if (fullPayload) {
      console.log("changing stage");
      this.stateChangeHandler("openBazar", "stage", false);
      this.props.onSelectRecord({ path: path, key: key });
      this.props.onSetUiFlag("operationType", "update");
    }
  };

  handleAddNew = stageName => {
    let initData = getInitData(
      this.state.tableName,
      this.props.createTable,
      this.props.userProfile
    );

    if (initData && initData !== undefined) {
      this.stateChangeHandler(stageName, "stage", false);

      this.props.onSetUiFlag("operationType", "add");
      this.props.onSetUiFlag("tableName", this.state.tableName);
      this.props.onAddNew({
        path: this.state.tableName,
        data: { ...initData }
      });
    } else {
      console.log("no init");
      // console.log(
      //   "tableName: " +
      //     this.state.tableName +
      //     " crTable: " +
      //     JSON.stringify(this.props.createTable) +
      //     " " +
      //     JSON.stringify(initData)
      // );
    }
  };

  backToList = listName => {
    console.log("setting stage to order list");
    this.stateChangeHandler(listName, "stage", false);
  };

  getDashView = () => {
    return <div></div>;
  };

  getFields = () => {
    ////console.log("test");
    alert("test");
  };

  getData = () => {
    let dTableName = this.state.tableName;

    if (this.state.tableName === "viewReports") {
      dTableName = "reports";
    }
    if (dTableName !== "dashboard") {
      if (
        this.state.tableDefs[dTableName] &&
        this.state.tableDefs[dTableName] !== undefined &&
        this.state.refPhoneNumber &&
        this.state.refPhoneNumber !== ""
      ) {
        return searchRecords(
          this.props.db[dTableName],
          this.state.searchVal,
          this.state.tableDefs[dTableName].searches
            ? this.state.tableDefs[dTableName].searches
            : [],
          this.state.searchFilters,
          this.state.searchDateFilters,
          this.state.refPhoneNumber
        );
      } else {
        console.log("returning blank");
        return [];
      }
    }
  };

  doStateUpdateForSearch = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        searchVal: this.refs.searchText.value
      };
    });
  };

  doDelaySearch = () => {
    ////console.log("doning search...");
    const q = this.refs.searchText.value;
    //this.stateChangeHandler("searchVal", q, false);
    if (q.length < 5) {
      this.getDataThrottled();
    } else {
      this.getDataDebounced();
    }
  };

  getSearchBar = () => {
    return (
      <div className="wrapzz">
        <div className="searchzz">
          <input
            type="text"
            className="searchTermzz"
            placeholder="Search..."
            ref="searchText"
            onKeyUp={() => this.doDelaySearch()}
          />
          <button
            type="submit"
            className="searchButtonzz"
            onClick={() => {
              this.setState(prevState => {
                return {
                  ...prevState,
                  searchVal: this.refs.searchText.value
                };
              });
              ////console.log("searchText " + this.refs.searchText.value);
              ////console.log(JSON.stringify(this.state.searchVal));
            }}
          >
            <i className="fa fa-search"></i>
          </button>
        </div>
      </div>
    );
  };

  getFiltersList = () => {
    let filtersList = [];
    if (this.props.createTable && this.props.createTable.length > 0) {
      let tableObj = this.props.createTable.find(
        item => item.name === this.state.tableName
      );

      if (tableObj && tableObj !== undefined) {
        if (tableObj.filters && tableObj.filters !== undefined) {
          filtersList = tableObj.filters;
        }
      }

      return filtersList;
    } else {
      return [];
    }
  };

  getFilterDropDowns = () => {
    if (this.state.showGrid) {
      return (
        <div>
          <GridFilters
            path={this.state.tableName}
            stateHandler={this.stateChangeHandler}
            value={this.state.searchFilters}
            ogTableDef={this.state.formDefs}
            filtersList={this.getFiltersList()}
          />
          <GridDateFilters
            path={this.state.tableName}
            stateHandler={this.stateChangeHandler}
            value={this.state.searchDateFilters}
            ogTableDef={this.state.formDefs}
            filtersList={this.getFiltersList()}
          />
        </div>
      );
    }
  };

  getGrid = () => {
    if (this.state.stage === "orderlist") {
      return (
        <div
          style={{
            overflow: "auto"
          }}
        >
          <WorkerGrid
            data={this.getData()}
            tableName={this.state.tableName}
            tableDef={this.state.tableDefs[this.state.tableName]}
            handleEdit={this.handleOrderEdit}
            handleDelete={this.handleDelete}
            role={"worker"}
          />
        </div>
      );
    }

    if (this.state.stage === "openBazarList") {
      return (
        <div
          style={{
            overflow: "auto"
          }}
        >
          <OpenBazarGrid
            data={this.getData()}
            tableName={this.state.tableName}
            tableDef={this.state.tableDefs[this.state.tableName]}
            handleEdit={this.handleBazarEdit}
            handleDelete={this.handleDelete}
            role={"worker"}
            phoneNumber={this.props.firebase.auth.currentUser.phoneNumber}
          />
        </div>
      );
    }
  };

  getInputField = (fieldName, poDefs) => {
    return getInputField(
      fieldName,
      "projectPos",
      this.state.data,
      this.stateChangeHandler,
      false,
      poDefs,
      this.props.db,
      isMobile
    );
  };

  getNewButton = () => {
    if (this.state.showGrid) {
      return (
        <Button
          colorScheme="primary"
          onPress={() => this.handleAddNew("orderpad")}
          text="SUBMIT NEW ORDER"
          fullWidth
        />
      );
    }
  };

  getTopHeader = () => {
    return (
      <table
        className={
          isMobile
            ? "table table-striped table-bordered table-sm"
            : "table table-striped table-bordered table-lg"
        }
      >
        <tbody>
          <td
            style={{
              textAlign: "center",
              padding: "5px"
            }}
          >
            {this.getNewButton()}
          </td>
        </tbody>
      </table>
    );
  };

  getNewBazarButton = () => {
    if (this.state.showGrid) {
      return (
        <Button
          colorScheme="primary"
          onPress={() => this.handleAddNew("openBazar")}
          text="POST MESSAGE IN BAZAR"
          fullWidth
        />
      );
    }
  };

  getBazarHeader = () => {
    return (
      <table
        className={
          isMobile
            ? "table table-striped table-bordered table-sm"
            : "table table-striped table-bordered table-lg"
        }
      >
        <tbody>
          <td
            style={{
              textAlign: "center",
              padding: "5px"
            }}
          >
            {this.getNewBazarButton()}
          </td>
        </tbody>
      </table>
    );
  };

  storeAutoLoginToApp = phoneNumber => {
    let elemEmail = document.getElementById("email");
    let elemPass = document.getElementById("password");
    let tmpEmail = "";
    let tmpPass = "";
    if (elemEmail && elemEmail.value !== "") {
      tmpEmail = elemEmail.value;
    }

    if (elemPass && elemPass.value !== "") {
      tmpPass = elemPass.value;
    }
    let msgToApp = {
      actionType: "storeAutoLogin",
      payload: {
        email: tmpEmail,
        password: tmpPass,
        company: phoneNumber
      }
    };

    if (window && window.ReactNativeWebView) {
      //console.log("posing autologin message to app");
      window.ReactNativeWebView.postMessage(JSON.stringify(msgToApp));
    }
  };

  getUiForAuth = () => {
    if (
      !this.state.notInitialized &&
      this.props.firebase &&
      this.props.firebase.phoneAuthProvider.PROVIDER_ID
    ) {
      //console.log("heaven");
      return (
        <StyledFirebaseAuth
          uiConfig={{
            // Popup signin flow rather than redirect flow.
            signInFlow: "popup",
            // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
            signInSuccessUrl: "/workers",
            // We will display Google and Facebook as auth providers.

            signInOptions: [
              {
                provider: this.props.firebase.phoneAuthProvider.PROVIDER_ID,
                recaptchaParameters: {
                  type: "image", // 'audio'
                  size: "invisible", // 'invisible' or 'compact'
                  badge: "bottomleft" //' bottomright' or 'inline' applies to invisible.
                },
                defaultCountry: "SG", // Set default country to the United Kingdom (+44).
                // For prefilling the national number, set defaultNationNumber.
                // This will only be observed if only phone Auth provider is used since
                // for multiple providers, the NASCAR screen will always render first
                // with a 'sign in with phone number' button.
                defaultNationalNumber: "",
                // You can also pass the full phone number string instead of the
                // 'defaultCountry' and 'defaultNationalNumber'. However, in this case,
                // the first country ID that matches the country code will be used to
                // populate the country selector. So for countries that share the same
                // country code, the selected country may not be the expected one.
                // In that case, pass the 'defaultCountry' instead to ensure the exact
                // country is selected. The 'defaultCountry' and 'defaultNationaNumber'
                // will always have higher priority than 'loginHint' which will be ignored
                // in their favor. In this case, the default country will be 'GB' even
                // though 'loginHint' specified the country code as '+1'.
                loginHint: ""
              }
            ]
          }}
          firebaseAuth={this.props.firebase.auth}
        />
      );
    } else {
      //console.log("hell");
    }
  };

  getLoginPage = () => {
    return (
      <div
        style={{
          marginTop: "40px"
        }}
      >
        <div style={{ textAlign: "center" }}>
          <LazyLoadImage src={photo.url} style={{ minHeight: "200px" }} />
        </div>
        <div
          style={{
            fontSize: "medium",
            fontWeight: "bold",
            margin: "5px",
            textAlign: "center"
          }}
        >
          <div
            style={{
              marginTop: "5px"
            }}
          >
            Welcome to BCS
          </div>

          <div
            style={{
              marginTop: "5px",
              marginBottom: "30px"
            }}
          ></div>
        </div>
        <div
          style={{
            border: "0px solid grey",
            borderRadius: "5px",
            padding: "5px"
          }}
        >
          <div
            style={{
              marginTop: "3px",
              marginBottom: "3px"
            }}
          >
            {this.getUiForAuth()}
            {/* <TextInputField
              title={""}
              value={this.state.phoneNumber}
              stateChangeHandler={(val, id, isPayload) =>
                this.stateChangeHandler(val, id, false)
              }
              fieldName={"phoneNumber"}
              disabled={false}
              type={null}
              message={""}
              id="company"
              placeholder={"98761234"}
            /> */}

            {window.location.hostname !== this.state.localhost && (
              <input
                type="hidden"
                className="form-control"
                id="company"
                ref="company"

                //value="test@test.com"
              />
            )}

            {window.location.hostname === this.state.localhost && (
              <input
                type="hidden"
                className="form-control"
                id="company"
                ref="company"
                value={localState.phoneNumber}
              />
            )}

            <input
              className="form-control"
              id="email"
              ref="email"
              type="hidden"

              //value="test@test.com"
            />

            <input
              className="form-control"
              id="password"
              secure
              ref="password"
              type="hidden"
              disabled={this.state.loginProgress}
            />
          </div>

          <div
            style={{
              marginTop: "3px",
              marginBottom: "3px",
              textAlign: "center",
              margin: "10px"
            }}
          ></div>
        </div>
      </div>
    );
  };

  getMarketingBox = () => {
    return (
      <div>
        <div
          style={{
            fontSize: "medium",
            fontWeight: "bold",
            margin: "5px",
            textAlign: "left"
          }}
        >
          <div
            style={{
              marginTop: "5px"
            }}
          >
            We are continously improving to serve you better!
          </div>
        </div>
      </div>
    );
  };

  storeAdmin = phoneNumber => {
    let allMenus = {};
    let allMenusFromDb = this.props.menuDesigner;

    if (this.props.users && this.props.users.length > 0) {
      let tgtUser = this.props.users.find(uItem => {
        if (
          uItem.userMobile &&
          uItem.userMobile !== "" &&
          uItem.userMobile.includes(phoneNumber)
        ) {
          //console.log(uItem.userMobile + " is true");
          return true;
        } else {
          //console.log(uItem.userMobile + " is false");

          return false;
        }
      });

      //checked and found users
      if (tgtUser && tgtUser !== undefined) {
        if (tgtUser.roleName && tgtUser.roleName !== "") {
          //setting users profile here, this is meant to be the storeadmin or admin
          this.props.onAddRecord({
            path: "userProfile",
            payload: tgtUser
          });
          this.props.onSetUiFlag("currUserRole", tgtUser.roleName);

          //sorting out user menus
          if (allMenusFromDb && allMenusFromDb.length > 0) {
            let userMenu = allMenusFromDb.find(
              singMenu => singMenu.name === tgtUser.roleName
            );
            if (userMenu) {
              allMenus = userMenu.menuItems.map(singleMenu => {
                let srcTable = this.props.listOfTables.find(
                  item => item.name === singleMenu.tableName
                );
                if (srcTable && srcTable !== undefined && srcTable.name) {
                  return {
                    ...singleMenu,
                    menuCaption: srcTable.menu
                  };
                }
              });
              let allTableDets = allMenus;
              if (allTableDets && allTableDets.length > 0) {
                for (let k = 0; k < allTableDets.length; k++) {
                  //console.log(JSON.stringify(allTableDets[k]));
                  this.loadDataEx(allTableDets[k]);
                }
              } else {
                console.log("tables not linked");
              }
              this.props.onSetUiFlag("userMenus", allMenus);
            }
          } else {
            console.log("menus not received in time");
          }
          //returning true for storeAdmin or SuperAdmin
          return (
            tgtUser.roleName === "STOREADMIN" ||
            tgtUser.roleName === "SUPERADMIN"
          );
        }
      } else {
        //not an admin, this will sendback false and enable worker menus
        if (allMenusFromDb && allMenusFromDb.length > 0) {
          let userMenu = allMenusFromDb.find(
            singMenu => singMenu.name === "WORKER"
          );
          if (userMenu) {
            console.log("found WORKER menu");
            allMenus = userMenu.menuItems.map(singleMenu => {
              let srcTable = this.props.listOfTables.find(
                item => item.name === singleMenu.tableName
              );
              if (srcTable && srcTable !== undefined && srcTable.name) {
                return {
                  ...singleMenu,
                  menuCaption: srcTable.menu
                };
              }
            });
            let allTableDets = allMenus;
            if (allTableDets && allTableDets.length > 0) {
              for (let k = 0; k < allTableDets.length; k++) {
                //console.log(JSON.stringify(allTableDets[k]));
                this.loadDataEx(allTableDets[k]);
              }
            } else {
              console.log("tables not linked");
            }
            this.props.onSetUiFlag("userMenus", allMenus);
          }
        } else {
          console.log("menus not received in time");
        }
      }
    } else {
      //alert("users not found " + JSON.stringify(this.props.users));
    }
    return false;
  };

  setupMenusNRole = (phoneNumber, enterAsWorker) => {
    console.log("setting menus");
    let thisIsWorker = true;
    let roleName = "WORKER";
    if (!enterAsWorker && this.props.users && this.props.users.length > 0) {
      let tgtUser = this.props.users.find(uItem => {
        if (
          uItem.userMobile &&
          uItem.userMobile !== "" &&
          uItem.userMobile.includes(phoneNumber)
        ) {
          //console.log(uItem.userMobile + " is true");
          return true;
        } else {
          //console.log(uItem.userMobile + " is false");

          return false;
        }
      });

      if (tgtUser && tgtUser !== undefined) {
        //admin or store admin
        if (tgtUser.roleName && tgtUser.roleName !== "") {
          this.props.onAddRecord({
            path: "userProfile",
            payload: tgtUser
          });
          thisIsWorker = false;
          roleName = tgtUser.roleName;
        }
      }

      //setup menus
      let allMenus = {};
      let allMenusFromDb = this.props.menuDesigner;
      if (allMenusFromDb && allMenusFromDb.length > 0) {
        let userMenu = allMenusFromDb.find(
          singMenu => singMenu.name === roleName
        );

        allMenus = userMenu.menuItems.map(singleMenu => {
          let srcTable = this.props.listOfTables.find(
            item => item.name === singleMenu.tableName
          );
          if (srcTable && srcTable !== undefined && srcTable.name) {
            return {
              ...singleMenu,
              menuCaption: srcTable.menu
            };
          }
        });
        let allTableDets = allMenus;
        if (allTableDets && allTableDets.length > 0) {
          for (let k = 0; k < allTableDets.length; k++) {
            //console.log(JSON.stringify(allTableDets[k]));
            this.loadDataEx(allTableDets[k]);
          }
        } else {
          console.log("tables not linked");
        }
        this.props.onSetUiFlag("userMenus", allMenus);
        this.props.onSetUiFlag("currUserRole", roleName);
      }
    } else {
      ("roles not setup");
    }
  };

  loadBasicData = (nextAction, enterAsWorker) => {
    console.log("setting up basic stuff");
    if (
      this.props.notLoadedBasicData &&
      this.props.firebase &&
      this.props.firebase.auth &&
      this.props.firebase.auth.currentUser
    ) {
      let refPhoneNumber = this.props.firebase.auth.currentUser.phoneNumber;
      refPhoneNumber = refPhoneNumber.replace("+65", "");
      this.storeAutoLoginToApp(refPhoneNumber);
      this.props.onSetUiFlag(
        "cellPhone",
        this.props.firebase.auth.currentUser.phoneNumber
      );
      this.stateChangeHandler(refPhoneNumber, "refPhoneNumber", "");
      if (
        refPhoneNumber !== null &&
        refPhoneNumber !== undefined &&
        refPhoneNumber !== ""
      ) {
        this.props
          .loadFbData("createTable", this.props.firebase, true)
          .then(crTableRes => {
            //console.log("crtable done");
            this.props
              .loadFbData("deliveryRequest", this.props.firebase, false)
              .then(listRes => {
                //console.log("deliveryRequest done");
              });
            this.props
              .loadFbData("listOfTables", this.props.firebase, true)
              .then(listRes => {
                //console.log("listOfTables done");
                this.props
                  .loadFbData("menuDesigner", this.props.firebase, true)
                  .then(desRes => {
                    console.log("loaded all");
                    this.props
                      .loadFbData("users", this.props.firebase, true)
                      .then(listRes => {
                        Promise.all([
                          this.setupMenusNRole(refPhoneNumber, enterAsWorker)
                        ]).then(resOut => {
                          console.log("done load all");
                          if (this.props.currUserRole === "WORKER") {
                            //this user is a worker
                            console.log("entering as non admin now");
                            if (!enterAsWorker) {
                              alert(
                                "You are not registered as a supplier. Please contact Kabir Hossain at +65 94562455 to sign-up as a supplier."
                              );
                            } else {
                              if (nextAction === "orderpad") {
                                this.handleAddNew(nextAction);
                              } else {
                                this.stateChangeHandler(
                                  nextAction,
                                  "stage",
                                  false
                                );
                              }
                            }
                          } else {
                            if (!enterAsWorker) {
                              console.log("yes this is non worker account");
                              this.stateChangeHandler(
                                nextAction,
                                "stage",
                                false
                              );
                            } else {
                              //menu problem
                              if (nextAction === "orderpad") {
                                this.handleAddNew(nextAction);
                              } else {
                                this.stateChangeHandler(
                                  nextAction,
                                  "stage",
                                  false
                                );
                              }
                            }
                          }
                          this.props.onSetUiFlag("notLoadedBasicData", false);
                        });
                      });
                  });
              });
          })
          .catch(error => {
            console.log("some error " + error);
          });
      }
    } else {
      console.log("waiting for auth");
    }
  };

  doLogin = (nextAction, enterAsWorker) => {
    this.loadBasicData(nextAction, enterAsWorker);
    console.log("moved in");
  };

  getMediaEntry = (
    vidUrl,
    headerText,
    descriptionText,
    forceWorker,
    buttonTitle1,
    nextAction1,
    buttonTitle2,
    nextAction2,
    tableName
  ) => {
    return (
      <div
        style={{
          textAlign: "center",
          width: "100%",
          marginTop: "15px"
        }}
      >
        <div
          style={{
            textAlign: "center",
            border: "2px solid gainsboro",
            padding: "1px",
            maxWidth: "800px",
            margin: "auto",
            borderRadius: "10px",
            backgroundColor: "white"
          }}
        >
          <div
            style={{
              marginLeft: "5px",
              marginRight: "5px",
              textAlign: "left"
            }}
          >
            <h2
              style={{
                marginTop: "5px"
              }}
            >
              {headerText}
            </h2>
            <div
              style={{
                marginBottom: "10px",
                marginTop: "-10px"
              }}
            >
              {descriptionText}
            </div>
          </div>
          <YouTube
            videoId={vidUrl}
            opts={{
              height: "240",
              width: "100%",
              playerVars: {
                // https://developers.google.com/youtube/player_parameters
                autoPlay: 0,
                controls: 1,
                loop: 1,
                modestbranding: 0,
                rel: 0,
                showinfo: 0
              }
            }}
            onReady={this._onReady}
          />
          {this.props.loginProgress && (
            <div style={{ margin: "1em" }}>
              <Preloader
                kind="linear"
                indeterminate
                height="150"
                subtitle={"Connecting ..."}
                labelPositionX={"center"}
                labelPositionY={"bottom"}
              />
            </div>
          )}
          {buttonTitle1 !== "" && nextAction1 !== "" && (
            <div>
              {!this.props.loginProgress && (
                <div>
                  <div
                    style={{
                      padding: "0.6em 2em",
                      borderRadius: "8px",
                      color: "#fff",
                      backgroundColor: "#1976d2",
                      fontSize: "1.1em",
                      border: "0px",
                      cursor: "pointer",
                      margin: "1em",
                      fontWeight: "bold"
                    }}
                    onClick={() => {
                      this.stateChangeHandler(tableName, "tableName", false);
                      this.doLogin(nextAction1, forceWorker);
                      window.document.querySelector(".content").scroll(0, 0);
                    }}
                  >
                    {buttonTitle1}
                  </div>
                </div>
              )}
            </div>
          )}
          {buttonTitle2 &&
            buttonTitle2 !== "" &&
            nextAction2 &&
            nextAction2 !== "" && (
              <div>
                {!this.props.loginProgress && (
                  <div>
                    <div
                      style={{
                        padding: "0.6em 2em",
                        borderRadius: "8px",
                        color: "#fff",
                        backgroundColor: "#1976d2",
                        fontSize: "1.1em",
                        border: "0px",
                        cursor: "pointer",
                        margin: "1em",
                        fontWeight: "bold"
                      }}
                      onClick={() => {
                        this.stateChangeHandler(tableName, "tableName", false);
                        this.doLogin(nextAction1, forceWorker);
                        window.document.querySelector(".content").scroll(0, 0);
                      }}
                    >
                      {buttonTitle2}
                    </div>
                  </div>
                )}
              </div>
            )}
        </div>
      </div>
    );
  };

  getMainContent = () => {
    return (
      <Container>
        {this.state.stage !== "login" && this.getTopMenu()}
        {/* {this.state.isSignedIn && !this.props.doneLogin && this.doLogin()} */}
        {this.state.isSignedIn && this.state.stage === "login" && (
          <div
            style={{
              margin: "auto",
              textAlign: "center",
              marginTop: "5px"
            }}
          >
            <h1>Welcome to BCS</h1>
            <div>
              You are signed in as{" "}
              {this.props.firebase.auth.currentUser.phoneNumber}
            </div>
            <div style={{ marginTop: "5px", marginBottom: "10px" }}>
              <Button
                text="Sign Out / Switch Number"
                colorScheme="flat"
                onPress={() => this.switchMenu("signout")}
                fullWidth
                radius={"rounded"}
              />
            </div>
            {this.getMediaEntry(
              "zxcNQkLMkbU",
              "Order Grocery",
              "With BCS, you can order any thing in seconds. Watch this video to find out more.",
              true,
              "ORDER NOW",
              "orderpad",
              "VIEW YOUR ORDERS",
              "orderlist",
              "deliveryRequest"
            )}
            {this.getMediaEntry(
              "IMuGBDgqDWw",
              "Open Bazar",
              "Connect with community, get updates, share the joy, ask or offer help, buy and sell. Watch this this video to find out more.",
              false,
              "ENTER OPEN BAZAR NOW",
              "openBazarList",
              "",
              "",
              "openBazar"
            )}
            {this.getMediaEntry(
              "euA3YQsfhFg",
              "",
              "Learn BCS",
              "Watch this video to learn how to use the BCS App for ordering groceries.",
              ""
            )}
            {this.getMediaEntry(
              "euA3YQsfhFg",
              "admin",
              "Supplier Login",
              "Watch this video to learn how to use the BCS App if you are our supplier partner.",
              "ENTER",
              false
            )}
            {this.getMediaEntry(
              "euA3YQsfhFg",
              "",
              "Join BCS",
              "Do you want to become a partner with us? Watch this video to find out more or send a whatsapp at +6594562455",
              ""
            )}
            <div style={{ textAlign: "left" }}>{termsMainPage()}</div>
          </div>
        )}

        {this.state.stage === "orderlist" && this.getTopHeader()}
        {this.state.stage === "openBazarList" && this.getBazarHeader()}
        {this.getGrid()}

        {this.state.stage === "orderpad" && (
          <OrderPad
            path={this.state.tableName}
            backToList={this.backToList}
            handleDelete={this.handleDelete}
            ogTableDef={getExtendedOgDefs(this.props.createTable)}
            genNotification={this.genNotification}
            cellPhone={this.state.refPhoneNumber}
          />
        )}
        {this.state.stage === "openBazar" && (
          <SingleRecord
            path={this.state.tableName}
            handleEditCancel={() => this.backToList("openBazarList")}
            handleDelete={this.handleDelete}
            ogTableDef={getExtendedOgDefs(this.props.createTable)}
            genNotification={() => {}}
            cellPhone={this.state.refPhoneNumber}
          />
        )}
      </Container>
    );
  };

  getLandingPage = () => {
    let tmpEmail = "";
    let tmpPassword = "";

    if (this.refs.email && this.refs.email.value) {
      console.log(this.refs.email.value);
      tmpEmail = this.refs.email.value;
    }

    if (this.refs.password && this.refs.password.value) {
      console.log(this.refs.password.value);
      tmpPassword = this.refs.password.value;
    }

    return (
      <DirectAdmin
        company={this.state.refPhoneNumber}
        email={tmpEmail}
        password={tmpPassword}
        stateChangeHandler={this.stateChangeHandler}
      />
    );
  };

  render() {
    return (
      <div>
        <div className="content">
          {this.state.stage === "admin" && this.getLandingPage()}
          <div>{this.state.stage !== "admin" && this.getMainContent()}</div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    userProfile: state.db.userProfile,
    userMenus: state.ui.userMenus,
    users: state.db.users,
    projects: state.db.projects,
    attendance: state.db.attendance,
    contacts: state.db.contacts,
    logistics: state.db.logistics,
    notices: state.db.notices,
    projectInvoices: state.db.projectInvoices,
    deletedprojectInvoices: state.db.deletedprojectInvoices,
    projectClaims: state.db.projectClaims,
    projectDos: state.db.projectDos,
    projectPos: state.db.projectPos,
    projectQuotes: state.db.projectQuotes,
    reports: state.db.reports,
    suppliers: state.db.suppliers,
    tasks: state.db.tasks,
    currentUser: state.db.userProfile,
    isAdmin: state.ui.isThisAdmin,
    isSuperAdmin: state.ui.isThisSuperAdmin,
    userUid: state.ui.userUid,
    currUserRole: state.ui.currUserRole,
    createFields: state.db.createFields,
    createTable: state.db.createTable,
    testTable: state.db.testTable,
    listOfTables: state.db.listOfTables,
    menuDesigner: state.db.menuDesigner,
    cellPhone: state.ui.cellPhone,
    uploadButton:
      state.ui.dataUploadButton && state.ui.dataUploadButton !== undefined
        ? state.ui.dataUploadButton
        : false,
    db: state.db,
    loginProgress: state.ui.loginProgress,
    userMenus: state.ui.userMenus,
    notLoadedBasicData: state.ui.notLoadedBasicData
  };
}

const mapDispatchToProps = dispatch => {
  return {
    onAddRecord: data => dispatch(actionAddArray2Redux(data)),
    onSelectRecord: params => {
      dispatch(selectARecord(params));
      dispatch(setUiFlag("tableName", params.path));
    },
    onAddNew: data => dispatch(initSelectedRecord(data)),
    loadStats: parsedRes => dispatch(loadAllStats(parsedRes)),
    onSetUiFlag: (flagName, flagVal) => dispatch(setUiFlag(flagName, flagVal)),
    onSignOut: () => {
      dispatch(resetRedux());
      dispatch(setUiFlag("userMenus", []));
    },
    loadFbData: (tableName, firebase, onceOnly) =>
      dispatch(loadFbData(tableName, firebase, onceOnly)),
    onNotifyUsers: (msgBody, arrayOfUsers) =>
      dispatch(notifyUsers(msgBody, arrayOfUsers)),
    onGetId: data => dispatch(getId(data)),
    onGetAcctStatement: data => dispatch(getAcctStatement(data)),
    onGetAcctBalance: data => dispatch(getAcctBalance(data)),
    onAddArray: data => dispatch(actionAddArray2Redux(data))
  };
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withFirebase
)(WorkerSecure);



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/WorkerSecure.jsx